import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useCopyMapConfigMutation, useDeleteMapConfigByIdMutation } from '@redux/api'

import { ROUTES } from '@constants'
import { CopyModelDataType, DataOfCopiedModelType } from '@types'

import { MapResponseType } from '../../../types/api/maps.api'

type IProps = {
  copyMapConfig: ReturnType<typeof useCopyMapConfigMutation>[0]
  deleteMapConfig: ReturnType<typeof useDeleteMapConfigByIdMutation>[0]
  isCopyingMapConfig: boolean
  isDeletingMapConfig: boolean
  setIdToDelete: (id: number | undefined) => void
  idToDelete?: number
}

export const useHandlers = (props: IProps) => {
  const {
    copyMapConfig,
    deleteMapConfig,
    isCopyingMapConfig,
    isDeletingMapConfig,
    setIdToDelete,
    idToDelete,
  } = props

  const navigate = useNavigate()

  const [maps, setMaps] = useState<MapResponseType[]>([])
  const [deleteCode, setDeleteCode] = useState<string>()
  const [copyId, setCopyId] = useState<number>()
  const [copyData, setCopyData] = useState<DataOfCopiedModelType>()

  const handleCreateMap = () => navigate(ROUTES.MAPS_CREATE)

  const handleEditMap = (id: number) => {
    navigate(ROUTES.MAPS_EDIT + `/${id}`)
  }

  const handleDeleteMap = () => {
    if (idToDelete) {
      deleteMapConfig({ id: idToDelete })
        .unwrap()
        .then(() => {
          setIdToDelete(undefined)
        })
    }
  }

  const handleShowDeleteModal = (id: number) => {
    setIdToDelete(id)
  }

  const handleCloseDeleteModal = () => {
    setIdToDelete(undefined)
  }

  const handleCopyMap = (data: CopyModelDataType) => {
    copyMapConfig({
      id: data.copyId,
      code: data.code,
      title: data.title,
    })
      .then(() => {
        // TODO add refetch all
      })
      .finally(() => {
        // TODO check this
        setCopyId(undefined)
      })
  }

  const handleShowCopyDialog = (id: number, title: string) => {
    setCopyId(id)
    setCopyData({
      id,
      title,
    })
  }

  const handleCloseCopyDialog = () => {
    setCopyId(undefined)
  }

  return {
    state: {
      maps,
      showCopyDialog: Boolean(copyId),
      copyData,
      isCopyingMapConfig,
      isDeletingMapConfig,
    },
    handlers: {
      handleEditMap,
      handleDeleteMap,
      handleCreateMap,
      handleCloseDeleteModal,
      handleShowDeleteModal,
      handleShowCopyDialog,
      handleCloseCopyDialog,
      handleCopyMap,
    },
  }
}
